import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

const getAccountId = (state) => resolveProp('session.auth.accountId', state);

export default createSelector(getAccountId, (accountId) => accountId);
